import React, {
 useState, useEffect, useCallback, useContext
} from 'react';
import {
 ConnectionList
} from './ConnectionList';
import {
 ConnectionForm
} from './ConnectionForm';
import {
 connectionService
} from 'shared/api/services/BEX';
import {
 useParams
} from 'react-router-dom';
import AlertModal from 'shared/components/Alertmodal';
import {
 Context
} from 'shared/context/GlobalState';
import {
 Connection
} from './Components/Types/ConnectionTypes';

// Type for route params
interface RouteParams extends Record<string, string> {
  appId: string;
  oragID: string;
}

// Model modal props
interface ModelProps {
  open: boolean;
  data: Partial<Connection>;
}

const ConnectionHome: React.FC = () => {
  const [reloadKey, setReloadKey] = useState<number>(0);
  const [connections, setConnections] = useState<Connection[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [delLoading, setDelLoading] = useState<boolean>(false);
  const [reloadConnections, setReloadConnections] = useState(false);
  const {
 addNewNotifcation
} = useContext(Context);
  const [view, setView] = useState<'dashboard' | 'form'>('dashboard');
  const {
 appId, oragID
} = useParams<RouteParams>();
  const [modelProps, setModelProps] = useState<ModelProps>({
    open: false,
    data: {}
  });
const fetchConnections = useCallback(async () => {
  setIsLoading(true);

  try {
    // Use getConnections instead of getAllConnectionIds
    const existingConnections = await connectionService.getConnections(oragID,appId);

    if (Array.isArray(existingConnections) && existingConnections.length > 0) {
      const connections: Connection[] = existingConnections.map((connRes) => ({
        // id: connRes.id,
        connection_id: connRes.connection_id,
        orgId: connRes.org_id,
        appId: connRes.app_id,
        connection_name: connRes.connection_name,
        name: connRes.connection_name,
        description: connRes.description,
        source_type: connRes.source_type,
        advancedOptions: connRes.advanced_options ?? {},
        settings:connRes.settings ?? {},
      }));

      setConnections(connections);
    } else {
      setConnections([]);
    }
  } catch (error) {
    console.error('Failed to fetch connections:', error);
  } finally {
    setIsLoading(false);
  }
}, [appId, oragID]);

  useEffect(() => {
    fetchConnections();
  }, []);
  useEffect(() => {
    setReloadKey((prev) => prev + 1);
  }, [connections]);
  useEffect(() => {
    if (reloadConnections) {
      fetchConnections();
      setReloadConnections(false);
    }
  }, [reloadConnections, fetchConnections]);

const handleConnectionSaved = async (savedConnection: Connection) => {
  try {
    setIsLoading(true);

    setConnections((prev) => {
      const isUpdate = prev.some(
        (conn) => conn.connection_id === savedConnection.connection_id
      );

      if (isUpdate) {
        // ✅ Immediate UI update
        return prev.map((conn) =>
          conn.connection_id === savedConnection.connection_id
            ? savedConnection
            : conn
        );
      } else {
        // ✅ Add new
        return [...prev, savedConnection];
      }
    });

    // ✅ Optionally refresh from backend to sync data
    await fetchConnections();

    setView('dashboard');
  } catch (err) {
    addNewNotifcation('Failed to refresh connections', 'error');
    console.error(err);
  } finally {
    setIsLoading(false);
  }
};

  const handleConnectionDeleted = (connection_id: string) => {
    setConnections((prevConnections) => prevConnections.filter((conn) => conn.connection_id !== connection_id));
    setReloadConnections(true);
  };
const handleBulkConnectionsDeleted = (deletedIds: string[]) => {
  setConnections((prevConnections) =>
    prevConnections.filter((conn) => !deletedIds.includes(conn.connection_id))
  );
  setReloadConnections(true);
};

  const showNewConnectionPage = () => {
    setView('form');
  };

  const showDashboard = () => {
    setView('dashboard');
  };

  const handleDeleteConnection = async () => {
    try {

      setDelLoading(true);
      await connectionService.deleteConnection(
        modelProps.data.orgId,
        modelProps.data.appId,
        modelProps.data.connection_id,
      );
      handleConnectionDeleted(modelProps.data.connection_id);
      addNewNotifcation('Connection deleted successfully', 'success');
      setReloadConnections(true);
    } catch (error) {
      console.error('Failed to delete connection:', error);
      addNewNotifcation('Failed to delete connection. Please try again.', 'error');
    } finally {
      setDelLoading(false);
      setModelProps({
        open: false,
        data: {}
      });
    }
  };

  return (
      <div className="w-full h-full overflow-auto">
          <div className="min-h-screen bg-gradient-to-br">
              <div className="w-full px-12 py-12 max-w-8xl">
                  {view === 'form' ? (
                      <ConnectionForm onConnectionSaved={handleConnectionSaved} onCancel={showDashboard} />
          ) : (
              <ConnectionList
                      key={reloadKey}
                      connections={connections}
                      isLoading={isLoading}
                      onConnectionSaved={handleConnectionSaved}
                      onDelete={handleConnectionDeleted}
                      onBulkDelete={handleBulkConnectionsDeleted}
                      setModelProps={setModelProps}
                      handleConnectionDeleted={handleConnectionDeleted}
                      onNewConnection={showNewConnectionPage}
                    />

          )}
              </div>
          </div>

          <AlertModal
        loading={delLoading}
        openModal={modelProps.open}
        setopenModal={(value: boolean) =>
          setModelProps((prev) => ({
            ...prev,
            open: value
          }))
        }
        onDelete={handleDeleteConnection}
      />
      </div>
  );
};

export default ConnectionHome;
